export enum ApplicationEnums {
    CUSTOMER = "1",
    COOK = "2",
}
